import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { tplTaskActions } from './slice';
import capabilities from './capabilities';

export const ApiTplTasksGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplTaskActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/tasks/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplTaskActions.setList(response?.data?.list));
                    dispatch(tplTaskActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplTaskActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplTasksCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('tplmgmt/tasks/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiTplTasksPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplTaskActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/tasks', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplTaskActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplTaskActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplTasksDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplTaskActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/tasks/delete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplTaskActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplTaskActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplTasksPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplTaskActions.startLoading());
    }

    await gestopAPI
        .put(`tplmgmt/tasks/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplTaskActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplTaskActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplTasksPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplTaskActions.startLoading());
    }

    await gestopAPI
        .patch(`tplmgmt/tasks/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplTaskActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplTaskActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplTasksDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplTaskActions.startLoading());
    }

    await gestopAPI
        .delete(`tplmgmt/tasks/${id}`, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplTaskActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplTaskActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplTasksGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplTaskActions.startLoading());
    }

    await gestopAPI
        .get(`tplmgmt/tasks/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplTaskActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplTaskActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
